import { Routes } from '@angular/router';
const ɵ0 = () => import("./members-search/members-search.module.ngfactory").then(m => m.MembersSearchModuleNgFactory), ɵ1 = () => import("./members-search/members-search.module.ngfactory").then(m => m.MembersSearchModuleNgFactory);
const routes = [{
        path: '', loadChildren: ɵ0
    },
    { path: 'search', loadChildren: ɵ1 }
];
export class InfoPageRoutingModule {
}
export { ɵ0, ɵ1 };
